import { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

const Landing = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname === "/") navigate("/participar-comunidade");
  }, [location, navigate]);

  return (
      <Outlet />
  );
};

export default Landing;
